import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";
import ReimburseComponent from "../ReimburseComponent/ReimburseComponent";
import { useNavigate, useLocation } from "react-router-dom";

const AllReimbursements = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("All Reimbursements"));
    fetchAllReimbursement();
  }, []);

  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");

  const intialFilterFormData = [
    { label: "Employee", value: "" },
    { label: "Status", value: "" },
    { label: "Project", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ];

  const [expenseData, setExpenseData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [empList, setEmplist] = useState([]);
  const [Status, setStatus] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [respStatus, setRepStatus] = useState(0);
  const [filterFormData, setFilterData] = useState(intialFilterFormData);
  const [apiStatus, SetApiStatus] = useState(undefined);

  const columns = {
    Name: { text: "Employee", visible: true },
    ProjectName: { text: "Project", visible: true },
    SuperiorName: { text: "Manager", visible: true },
    FromDate: { text: "From", align: "center", visible: true },
    ToDate: { text: "To", align: "center", visible: true },
    AdvanceAmountBASE: {
      text: "Advance Amt. (\u20B9)",
      align: "end",
      visible: true,
    },
    TotalExpense: {
      text: "Total Expense (\u20B9)",
      align: "end",
      visible: true,
    },
    ApprovedAmountBASE: {
      text: "Approved Amt. (\u20B9)",
      align: "end",
      visible: true,
    },
    BalanceAmountBASE: {
      text: "Balance Amt. (\u20B9)",
      align: "end",
      visible: true,
    },
    Status: { text: "Status", visible: true },
    ActionByName: { text: "Action By", visible: true },
    PayrollMonth: { text: "Payroll Month", align: "center", visible: true },
  };

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const fetchAllReimbursement = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/4?P_ProjectID=${0
        }&P_EmployeeID=${0
        }&P_Status=${0
        }&P_FromDate=${lastMonthDate
        }&P_ToDate=${todayDate
        }`
      );
      if (response.status === 200) {
        SetApiStatus(response?.status);
        const ExpenseData = response?.data?.data?.header;
        setExpenseData(ExpenseData);
        // Employee list
        const empList = response?.data?.data?.employee?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmplist(empList);

        // status list
        const statusList = response?.data?.data?.statusList?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatus(statusList);

        // project list
        const projectList = response?.data?.data?.projects?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setProjectList(projectList);

        setRepStatus(response.status);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };
  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/4?P_ProjectID=${filterFormData.find((o) => o.label === "Project")
          ? filterFormData.find((o) => o.label === "Project").value
          : 0
        }&P_EmployeeID=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value
          : 0
        }&P_Status=${filterFormData.find((o) => o.label === "Status")
          ? filterFormData.find((o) => o.label === "Status").value
          : 0
        }&P_FromDate=${filterFormData.find((o) => o.label === "From Date")
          ? moment(
            filterFormData.find((o) => o.label === "From Date").value
          ).format("YYYY-MM-DD")
          : lastMonthDate
        }&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
          ? moment(
            filterFormData.find((o) => o.label === "To Date").value
          ).format("YYYY-MM-DD")
          : todayDate
        }`
      );
      if (response.status === 200) {
        SetApiStatus(response?.status);
        const ExpenseData = response?.data?.data?.header;
        setExpenseData(ExpenseData);
        // Employee list
        const empList = response?.data?.data?.employee?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmplist(empList);

        // status list
        const statusList = response?.data?.data?.statusList?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatus(statusList);

        // project list
        const projectList = response?.data?.data?.projects?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setProjectList(projectList);

        setRepStatus(response.status);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };

  const formDatas = [
    { name: "Employee", type: "Select", options: [...empList] },
    { name: "Status", type: "Select", options: [...Status] },
    { name: "Project", type: "Select", options: [...projectList] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
  ];
  const handleViewTnE = (id) => {
    navigate(`/new-tne/view/${id.ID}`, {
      state: { from: location.pathname },
    });
  };
  const handleTnE = (id) => {
    navigate(`/my-reimbursements/report/exportTne/${id.ID}`);
  };





  const handleFilterReset = () => {
    setFilterData(intialFilterFormData)
    fetchAllReimbursement()
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <ReimburseComponent
              data={expenseData}
              handleReset={handleFilterReset}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              showIcon1={true}
              showIcon2={true}
              isActionRequired={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              isFileDownloadRequired={true}
              searchTerm={searchTerm}
              responseStatus={respStatus}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              formDatas={formDatas}
              handleGetData={handleGetData}
              handleChange={handleChange}
              filterFormData={filterFormData}
              handleIcon1={handleViewTnE}
              handleIcon2={handleTnE}
              icons={{
                Icon1: <i className="bi bi-eye-fill"></i>,
                Icon1Text: "View TnE",
                Icon2: <i className="bi bi-download"></i>,
                Icon2Text: "Export TnE",
                Icon2Flag: "canExportTnE",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AllReimbursements;
